import React from 'react';
import {StyleSheet, TouchableOpacity} from 'react-native';

import * as RootNavigation from '../../navigation/RootNavigation';

import Text from './Text';

type LinkProps = {
  children: React.ReactNode;
  target: string;
  navigationParams?: any;
  navigation?: any;
  callback?: () => void;
};
const Link = ({
  children,
  target,
  navigation,
  navigationParams = {},
  callback,
}: LinkProps) => {
  const handlePress = () => {
    callback?.();
    if (navigation) {
      navigation.navigate(target, navigationParams);
    } else {
      RootNavigation.navigate(target, navigationParams);
    }
  };

  return (
    <TouchableOpacity onPress={handlePress}>
      <Text style={styles.link}>{children}</Text>
    </TouchableOpacity>
  );
};

export default Link;

const styles = StyleSheet.create({
  link: {
    color: '#0054A6',
  },
});
